import script from "./ChatInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatInput.vue?vue&type=script&setup=true&lang=ts"

import "./ChatInput.vue?vue&type=style&index=0&id=197534e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-197534e6"]])

export default __exports__